
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jpeg-to-bmp-converter",
      function () {
        return require("private-next-pages/jpeg-to-bmp-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jpeg-to-bmp-converter"])
      });
    }
  